export default __webpack_public_path__ + "static/media/city.12f00f55.png";